/* import __COLOCATED_TEMPLATE__ from './editor-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import templateOnlyComponent from '@ember/component/template-only';

const EditorEmptyState = templateOnlyComponent();
export default EditorEmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::EditorEmptyState': typeof EditorEmptyState;
  }
}
